import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Text } from 'components/Text';
import { Icon } from 'components';

const ChipButton = styled.span`
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 5px;
  background: ${Colors.SECONDARY};
  border-radius: 4px;

  & ${Text} {
    margin-right: 16px;
    color: ${Colors.PRIMARY};
  }

  & ${Icon} {
    opacity: 0.7;
  }

  & + & {
    margin-left: 5px;
  }
`;

export { ChipButton };
